import { action, observable } from 'mobx'
import { statisticsService } from '../../api/statistics/statistics'
import { withSpinner } from '../with-spinner'

export const DEFAULT_DATA_AUTO_REFRESH_TIME = 60000

export class MonitoringStore {

    @observable
    activeMarks = 0

    @observable
    soldMarks = 0

    @observable
    items = []

    dataAutoRefreshTime
    dataRefreshTimer

    @action
    fetchExciseCount = async () => {
        const exciseCount = await withSpinner(statisticsService.getExciseCount())

        if (exciseCount) {
            this.activeMarks = exciseCount.active
            this.soldMarks = exciseCount.sold
        }
    }

    @action
    fetchRequestHistory = async () => {
        const items = await withSpinner(statisticsService.getRequestHistory(10))

        if (items) {
            this.items = items
        }
    }

    @action
    fetchDataAutoRefreshTime = async () => {
        this.dataAutoRefreshTime = await withSpinner(statisticsService.getDataRefreshTime())
            || DEFAULT_DATA_AUTO_REFRESH_TIME
    }

    fetchData = () => {
        this.fetchExciseCount()
        this.fetchRequestHistory()
    }

    startAutoFetchingData = async () => {
        this.stopAutoFetchingData()
        await this.fetchDataAutoRefreshTime()
        this.fetchData()
        this.dataRefreshTimer = setInterval(this.fetchData, this.dataAutoRefreshTime)
    }

    @action
    stopAutoFetchingData = () => {
        if (this.dataRefreshTimer) {
            clearInterval(this.dataRefreshTimer)
            this.dataRefreshTimer = undefined
        }
    }

    reset = () => {
        this.activeMarks = 0
        this.soldMarks = 0
        this.items = []
        this.dataAutoRefreshTime = undefined
        this.stopAutoFetchingData()
    }
}
